/**
 * Reading mode on the song page: the top bar, the setlist row and the strip of open songs fold into
 * one floating button (ReadingButton), so the sheet gets the whole screen; the button brings the bars
 * back over the sheet (never shrinking it). Automatic on short screens (a phone in landscape), else
 * chosen with "Fela stikur" / "Festa stikur" — remembered per device (pure parts unit tested).
 */
import { useMediaQuery } from '../lib/useMediaQuery';
import { readPref, writePref } from './storage';

/** 'folded' / 'pinned' = chosen on this device; null = automatic. */
export type BarsPref = 'folded' | 'pinned' | null;

export const BARS_PREF_KEY = 'kgr.viewer.bars';
/** Short screens: a phone in landscape (an iPad never is). */
export const SHORT_SCREEN_QUERY = '(max-height: 520px)';

/** The bars are folded into the button: as chosen, else on a short screen. */
export function barsFolded(pref: BarsPref, shortScreen: boolean): boolean {
  return pref === null ? shortScreen : pref === 'folded';
}

const isPref = (v: unknown): v is BarsPref => v === 'folded' || v === 'pinned';

export function readBarsPref(): BarsPref {
  return readPref<BarsPref>(BARS_PREF_KEY, null, isPref);
}

export function writeBarsPref(pref: BarsPref): void {
  writePref(BARS_PREF_KEY, pref);
}

/** Whether the window is short (SHORT_SCREEN_QUERY), following rotation. */
export function useShortScreen(): boolean {
  return useMediaQuery(SHORT_SCREEN_QUERY);
}
